import React from 'react'
import styled from 'styled-components';
import {
  TooltipRenderProps,
} from 'react-joyride';

const closeIcon = require('app_assets/images/resources/close.svg')

const TooltipBody = styled.div`
  background-color: #fff;
  min-width: 290px;
  max-width: 420px;
  position: relative;
  border-radius: 10px;
  border: 1px solid #C1C8C8;
  padding: 8px;
  box-sizing: border-box;
`;

const TooltipContent = styled.div`
  color: #000;
  padding: 20px;
`;

const TooltipTitle = styled.h2`
  font-family: Catamaran;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 30px;
  text-align: center;
  color: #0085CA;
`;

const TooltipFooter = styled.div`
  display: flex;
  gap: 10px;
`;

const Tooltip = (props: TooltipRenderProps) => {
  const {
    continuous,
    index,
    size,
    isLastStep,
    step,
    backProps,
    primaryProps,
    skipProps,
    closeProps,
    tooltipProps,
  } = props;
  console.log('props', props)
  return (
    <TooltipBody {...tooltipProps} className="joy-ride-tooltip">
      <button className="close-button" {...closeProps}>
        <img src={closeIcon} alt=""/>
      </button>
      {step.title && <TooltipTitle className="title">{step.title}</TooltipTitle>}
      <div className="size">{index+1}/{size}</div>
      {step.content && <TooltipContent className="content">{step.content}</TooltipContent>}
      <TooltipFooter>
        {/* {!isLastStep && (
          <Button {...skipProps} spacer={true}>
            skip
          </Button>
        )}
         */}
        {/* <Button {...primaryProps}>
          {continuous ? 'next' : 'close'}
        </Button> */}
        {index > 0 && (
          <button className={`btn btn-primary navigate-back`}
          {...backProps}
          >
            Atras
          </button>
        )}
        <button className={`btn btn-primary navigate ${continuous ? 'continuous' : 'end'}`}
          {...primaryProps}
        >
          {continuous ? 'Siguiente' : 'Finalizar'}
        </button>
      </TooltipFooter>
    </TooltipBody>
  );
};

export default Tooltip
